/**
 * The battle model's fitted constants (62.17 step 2). Generated by `npm run sim:model-fit -- --write`;
 * edit by re-running the fit, not by hand. Null = not fitted yet (the model uses its unfitted numbers).
 * Fitted 2026-10-10 against 288 full real-time sector battles (cells 3v3, 6v6, 9v9, 6v3, 9v6, 12v8, garrisoned and open).
 */
import type { ModelParams } from './battleModel';

export const FITTED_PARAMS: ModelParams | null = {
  "killRate": 0.2333333333333333,
  "closeSeconds": 1.5,
  "objectiveSeconds": 45,
  "defenceGarrison": 0.9,
  "defenceOpen": 0.9,
  "defencePerStructure": 0.1,
  "pursuitShare": 0.5,
  "timeLimit": 300,
  "battleVersion": 14
};
